import { createContext } from "react";

export const EmailSupportContext = createContext({
  supportedCountries: [] as string[],
});
